module.exports = __webpack_public_path__ + "img/743b3d2.jpg";